import { EditSimpleIcon } from "@components/icon";
import { AmountWrapper, StyledEditableAmount } from "@components/smart/selectionTableView/SelectionTableView.styles";
import {
    ISelectionWithEditableAmountCustomTableData
} from "@components/smart/selectionTableView/SelectionTableView.utils";
import { SELECTION_TABLEVIEW_ACTION } from "@components/smart/selectionTableView/SelectionTableViewBase";
import { TSmartODataTableStorage } from "@components/smart/smartTable/SmartODataTableBase";
import React, { useCallback } from "react";

import { IconSize } from "../../../enums";

interface IProps {
    storage: TSmartODataTableStorage<ISelectionWithEditableAmountCustomTableData>;
    rowId: string;
    value: string;
    isReadOnly?: boolean;
    isRowSelected?: boolean; // info if the row is selected - we render the row differently, allow to edit the amount
}

const EditableAmount: React.FC<IProps> = ({ storage, rowId, isReadOnly, isRowSelected, value }) => {
    const handleClickAmount = useCallback((event: React.SyntheticEvent) => {
        storage.setCustomData({ pairedDialogItemId: rowId });
        storage.refresh();
        event.stopPropagation();
    }, [rowId, storage]);

    const isSelectionActionActive = storage.tableAction === SELECTION_TABLEVIEW_ACTION;

    return (<>
        <StyledEditableAmount
                renderAsFlex
                isDisabled={!isRowSelected || !isSelectionActionActive}
                onClick={handleClickAmount}>
            {isRowSelected && isSelectionActionActive && !isReadOnly &&
                    <EditSimpleIcon width={IconSize.XS} isLightHover/>
            }
            <AmountWrapper>
                {value}
            </AmountWrapper>
        </StyledEditableAmount>
    </>);
};

export default EditableAmount;